module.exports = new __parcel__URL__("strassburg.d83f02bb.webp").toString();